import { createRoot } from "react-dom/client";
import { initSentry, SentryErrorBoundary } from "./lib/sentry";
import { ErrorBoundaryFallback } from "./components/error-boundary-fallback";
import App from "./App";
import "./index.css";

initSentry();

createRoot(document.getElementById("root")!).render(
  <SentryErrorBoundary
    fallback={({ error, resetError }) => (
      <ErrorBoundaryFallback error={error} resetError={resetError} />
    )}
  >
    <App />
  </SentryErrorBoundary>,
);
